export enum EScolaMaterial {
    'Amiante ciment extérieur (Gaine / canalisation)',
    'Amiante ciment intérieur(Gaine / canalisation)',
    'Bitume',
    'Brai de houille',
    'Calorifugeage',
    'Chape maigre',
    'Colle bitumineuse',
    'Colle de carrelage',
    'Conduits métalliques revêtus',
    'Eléments de friction et éléments électriques',
    'Enduit de débullage',
    'Enduit de lissage',
    'Enduit épais(ou ciment)',
    'Faux - plafond(plaque fibrociment)',
    'Faux - plafond(carton amianté)',
    'Faux - plafond(panneau sandwich)',
    'Flocage',
    'Joint d\'installation domestique ou industrielle',
    'Mastic d\'étanchéité amianté',
    'Matériaux contaminés par un matériau amianté',
    'Matériels et équipements contaminés',
    'Mortier',
    'Peinture amiantée',
    'Peinture de revêtement épais intérieur / extérieur',
    'Plâtre amianté',
    'Porte ou clapet coupe - feu',
    'Porte palière d\'ascenseur',
    'Ragréage',
    'Résidu amianté issu de bâtiment sinistré(tornade - incendie) et de site pollué',
    'Revêtement de sol: dalle, lé, ...',
    'Revêtement intérieur(plaque fibrociment)',
    'Revêtement routier',
    'Revêtement sur support métallique(peinture, enduits)',
    'Terre et roche amiantifère naturelle',
    'Toiture - Bardage : Plaque plane ou ondulée, tuile, ardoise',
    'Tresse joint de dilatation ou pied de cloison',
}